import React from 'react'
import './HomeHeader.css'

const HomeHeader = (props) => {
	return (
		<React.Fragment>
			<header className='home-header'>{props.children}</header>
		</React.Fragment>
	)
}

export default HomeHeader
